export default __webpack_public_path__ + "9002e462db967d5e5d1465d1177b3d3e.svg";